import { env } from '../../config';
import { bizRequest } from "../../bizClient"; // Import the API helper

const getSlidesForContentLibrary = async (customer, userId, isAdmin) => {
    const url = `/api/slides/getSlidesForContentLibrary/${customer.id}/${userId}/${isAdmin}`;

    return await bizRequest(url)
        .then(data => {
            return data?.categories
        })
        .catch((error) => error);
}

const getSlideUploadUrl = async (customerId, slideKey, slideType, fileType) => {
    return await bizRequest(`/api/slides/getSlideUploadUrl/${customerId}/${slideKey}/${slideType}/${fileType}`)
    .then(response => response)
}

const uploadSlideToAws = async (url, file, type) => {
    return await fetch(url, {
        method: 'PUT',
        body: file,
        headers: {
            'Content-Type': type
        }
    })
    .then(response => {
        return response
    })
    .catch(error => {
        console.error(error);
    });
}

const createSlide = async (body) => {
    const url = `/api/slides/createSlide`;

    return await bizRequest(url, 'POST', { 'Content-Type': 'application/json' }, body)
    .then((response) => {
        return response;
    })
    .catch((error) => {
        console.error('Something went wrong:', error);
    });    
}

const updateSlide = async (id, body) => {
    return await bizRequest(`/api/slides/${id}`, 'PUT', { 'Content-Type': 'application/json' }, body)
    .then((response) => {
        return response;
    })
    .catch((error) => {
        console.error('Something went wrong:', error);
    });
}

const removeSlide = async(id) => {
    // Delete slide from Slides and PlaylistsSlides tables
    return await bizRequest(`/api/slides/remove/${id}`)
    .then((response) => {
        return response;
    })
    .catch((error) => {
        console.error('Something went wrong:', error);
    });
}

const buildMessagingUrl = (messagingConfigs)  => {
    if (!messagingConfigs || typeof messagingConfigs !== 'object') return env.MESSAGE_LOADER_URL;
    const params = Object.entries(messagingConfigs)
        .filter(([_, value]) => value !== null && value !== undefined)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');

    return env.MESSAGE_LOADER_URL + '?' + params;
}

const replaceUnderscore = (str, replaceString) => {
    if (!str) return str;
    return str.replace(/_/g, replaceString);
}

export {
    getSlidesForContentLibrary,
    getSlideUploadUrl,
    uploadSlideToAws,
    createSlide,
    updateSlide,
    removeSlide,
    buildMessagingUrl,
    replaceUnderscore
}
